<script setup>
import { computed } from 'vue';

/**
 * Visible FAQ block (ТЗ §3.8). The same `items` array is what the page feeds
 * into the FAQPage JSON-LD, keeping the rendered Q/A and the structured data
 * in lockstep. Accepts {q,a} or {question,answer} shapes.
 */
const props = defineProps({
    items: { type: Array, default: () => [] },
});

const faqs = computed(() =>
    (props.items || [])
        .map((item) => ({
            q: item?.q ?? item?.question ?? '',
            a: item?.a ?? item?.answer ?? '',
        }))
        .filter((item) => item.q && item.a)
);
</script>

<template>
    <section v-if="faqs.length" class="mt-6">
        <h2 class="font-['Unbounded'] text-lg font-medium mb-3 dark:text-slate-200">
            {{ $t('Frequently asked questions') }}
        </h2>
        <div class="flex flex-col gap-2">
            <details v-for="(item, i) in faqs" :key="i"
                     class="rounded-lg bg-slate-100 dark:bg-slate-800 px-4 py-3">
                <summary class="cursor-pointer font-medium text-base dark:text-slate-200">
                    {{ item.q }}
                </summary>
                <p class="mt-2 text-base leading-relaxed text-slate-700 dark:text-slate-300">
                    {{ item.a }}
                </p>
            </details>
        </div>
    </section>
</template>
